export default __webpack_public_path__ + "static/media/rent-icon.1fe04f60.svg";